export enum TILE_ACTION_ALIGNMENT {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}